import { Button } from "@/components/ui/button";
import {
	Dialog,
	DialogContent,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from "@/components/ui/dialog";
import {
	Form,
	FormControl,
	FormDescription,
	FormField,
	FormItem,
	FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { UseFormReturn } from "react-hook-form";

function ActivateAccountDialog({
	form,
	onSubmit,
	showActivateAccountDialog,
	setShowActivateAccountDialog,
	onResend,
}: {
	form: UseFormReturn<{ verificationCode: string }>;
	onSubmit: (data: { verificationCode: string }) => Promise<void>;
	showActivateAccountDialog: boolean;
	setShowActivateAccountDialog: (open: boolean) => void;
	onResend: React.MouseEventHandler<HTMLButtonElement>;
}) {
	return (
		<Dialog
			open={showActivateAccountDialog}
			onOpenChange={setShowActivateAccountDialog}
		>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>Activate account</DialogTitle>
				</DialogHeader>
				<Form {...form}>
					<form
						onSubmit={form.handleSubmit(onSubmit)}
						className="flex flex-col gap-3"
					>
						<FormField
							control={form.control}
							name="verificationCode"
							render={({ field }) => (
								<FormItem>
									<FormDescription>
										Please enter the verification code sent to your email.
									</FormDescription>
									<FormControl>
										<Input
											{...field}
											required
											placeholder="OTP Code"
											type="number"
											className="bg-light-input"
										/>
									</FormControl>
									<FormMessage />
								</FormItem>
							)}
						/>

						<DialogFooter className="mt-4 flex !flex-col items-center">
							<Button variant={"link"} type={"button"} onClick={onResend}>
								Resend
							</Button>
							<Button type="submit" className="w-75">
								Activate
							</Button>
						</DialogFooter>
					</form>
				</Form>
			</DialogContent>
		</Dialog>
	);
}

export default ActivateAccountDialog;
